import React from 'react';
import { History } from 'history';
import { Button, InputEmail, InputPassword, Text } from '../../components';
import BaseCreate from '../base/base-create.component'; 
import BaseView from '../base/base-view.component';
import Model from './user-model';  //editable..
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    root?: string;
    caption?: string;
    onSave?: (data: any) => void;
    disableAutoBack?: boolean;
    disableBackButton?: boolean;
    disableCard?: boolean;
}

interface IState {
    datarow: Model;
    errors: any;
    userId: number;
}


export default class UserAuthSignin extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            userId: 0,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onError = (data: any) => {
        this.setState({errors: data});
    }

    private onSave = async(data: any) => {
        if (data.id) {
            await this.setState({userId: data.id});
            await Model.setUser(data.id, data.name, data.imageUrl, data.token);
        }
        this.props.onSave?.(data);
    }
    
    private onClickSignup = () => {
        this.props.onSave?.(null); //trigger for closing dialog
        this.props.history.push('/usersignup', AppService.historyState());
    }

    private onLoad = async(data: any) => {
        if (data.id) await Model.setUserPersonalinfo(data.personalinfo, data.personalinfoCaption);
    }

    private onChange(fieldName: string, value?: string) { 
        var identifier = this.state.datarow.identifier;
        if (fieldName === 'useremail' && value) identifier = Model.getEmailApp(value);

        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value, identifier: identifier,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <>
            <BaseCreate history={this.props.history} caption={this.props.caption || Model.caption + ' Signin'} buttonCaption='Signin' successCaption='Signed in'
                endPoint={Model.endPointAuth + '/local'} model={Model} url={this.props.root} datarow={this.state.datarow} validations={Model.validationSignin} onError={this.onError} buttonOnBottom onSave={this.onSave} disableBackButton={this.props.disableBackButton} disableAutoBack={this.props.disableAutoBack} disableCard={this.props.disableCard}>              
                <InputEmail name='useremail' label='Email' value={this.state.datarow.useremail} error={this.state.errors?.identifier || this.state.errors?.[0]} box onChange={this.onChange} />
                <InputPassword name='password' label='Password' value={this.state.datarow.password} error={this.state.errors?.password} box onChange={this.onChange} />
                <Button label='Forget Password?' size='small' textTransform='capitalize' disablePadding sx={{display: 'block'}} onClick={() => {this.props.history.push('/userforgotpassword')}} />
            </BaseCreate>

            <Text label='Do not have an account?' size='extrasmall' displayBlock sx={{mt: 1, mb:3}}>
                <Button label='Signup Now' size='small' textTransform='capitalize' onClick={this.onClickSignup} />
            </Text>
            
            {this.state.userId > 0 &&
            <BaseView id={this.state.userId} caption='' 
                model={Model} onLoad={this.onLoad}/>
            }
            </>
        );
    }     
     
}